<template>
<div>
  <div class="emd-container">
    <div class="emd-container__header eu-py_4_md eu-px_5_md">
      <h2 class="emd-text _size_section _color_default">
        {{ $t('title') }}
      </h2>
    </div>
    <hr class="emd-divider">
    <div class="emd-container__content eu-pa_5_md">
      <emd-alert
        v-if="tabbarError.status"
        variant="danger"
        :title="$t('tabbarError')"
        @cancel="tabbarError.status = false"
        autoclose />
      <form action="">
        <div class="eu-flex eu-column eu-row_md">
          <div class="eu-flex-item eu-basis_4_md">
            <div class="emd-form-group">
              <label class="emd-label _required">{{ $t('dueDate') }}</label>
              <div class="emd-input-group">
                <input
                  v-mask="'##/##/####'"
                  v-model="boleto.due_at"
                  class="emd-input"
                  type="text"
                  placeholder="dd/mm/aaaa"
                  :class="{ '_state_error': $v.boleto.due_at.$invalid && showFeedbacks.status }" />
              </div>
              <p class="emd-input-feedback _state_error" v-if="$v.boleto.due_at.$invalid && showFeedbacks.status && !boleto.due_at.length">{{ $t('hint.required') }}</p>
              <p class="emd-input-feedback _state_error" v-if="$v.boleto.due_at.$invalid && showFeedbacks.status && boleto.due_at.length">{{ $t('hint.dueDate', { date: setDatePlaceHolder }) }}</p>
            </div>
          </div>
          <div class="eu-flex-item eu-basis_12">
            <div class="emd-form-group">
              <label class="emd-label">{{ $t('instructions') }}</label>
              <div class="emd-input-group">
                <input
                  class="emd-input"
                  type="text"
                  v-model="boleto.instructions"
                  :placeholder="$t('instructionsPlaceholder')" />
              </div>
            </div>
          </div>
          <div class="el-chunk eu-mt_4">
            <label class="emd-label _required">{{ $t('address.title') }}</label>
          </div>
          <div class="emd-form-box _border_base eu-basis_12_md" :class="{ '_active': true }">
            <div class="emd-form-box__content" v-if="shouldShowCheckBox">
              <label class="emd-checkbox" for="useclientaddress">
                <input class="emd-checkbox__input" name="useclientaddress" type="checkbox" id="useclientaddress" v-model="billingAddress.use_client_address" />
                <div class="emd-checkbox__area"></div>
                <span class="eu-ml_2">{{ $t('address.checkbox') }}</span>
              </label>
            </div>
            <div class="emd-form-box__content">
              <address-card v-if="shouldBeOpenAddressCard"/>
              <address-form v-else :address="billingAddress" :required="true" @toggle="toggleAddressFormState" />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="el-section">
    <div class="eu-display_flex eu-justify_space-between eu-wrap_reverse">
      <button class="emd-btn _color_secondary _type_text _block_mobile" @click="reverseRoute">
        <i class="uil uil-angle-left"></i>
        {{ $t('customer') }}
      </button>
      <button class="emd-btn _color_secondary _block_mobile eu-mb_5 eu-no-margin_sm" @click="nextRoute">
        {{ $t('review') }}
        <i class="uil uil-angle-right"></i>
      </button>
    </div>
  </div>
</div>
</template>

<script>
import EmdAlert from '@/components/emerald/molecules/EmdAlert'
import { required } from 'vuelidate/lib/validators'
import { validateDate, setCurrentDate } from '@/utils/validations'
import AddressForm from '@/components/project/AddressForm'
import AddressCard from '@/components/project/AddressCard'

export default {
  name: 'PaymentBoleto.vue',
  components: {
    EmdAlert,
    AddressForm,
    AddressCard
  },
  data () {
    return {
      addressFormIsInvalid: true
    }
  },
  computed: {
    boleto () {
      return this.$store.getters.boleto
    },
    formIsInvalid () {
      return this.$v.$invalid || (this.addressFormIsInvalid && !this.useClientAddress)
    },
    selectedPaymentType () {
      return this.$store.getters.selectedPaymentType
    },
    tabbarError () {
      return this.$store.getters.tabbarError
    },
    showFeedbacks () {
      return this.$store.getters.showFeedbacks
    },
    setDatePlaceHolder () {
      return setCurrentDate(0)
    },
    address () {
      return this.$store.getters.address
    },
    billingAddress () {
      return this.$store.getters.billing_address
    },
    useClientAddress () {
      if (this.address.show_address) return this.billingAddress.use_client_address
      else return false
    },
    shouldShowCheckBox () {
      return this.address.show_address
    },
    shouldBeOpenAddressCard () {
      return this.billingAddress.use_client_address && this.address.show_address
    }
  },
  validations: {
    boleto: {
      due_at: {
        required,
        validateDate
      }
    }
  },
  methods: {
    nextRoute () {
      if (this.formIsInvalid) {
        this.showFeedbacks.status = true
        this.showFeedbacks.address = true
      } else {
        this.$router.push({ name: 'ReviewOrder' })
      }
    },
    reverseRoute () {
      this.$router.push({ name: 'Customer' })
    },
    toggleAddressFormState (state) {
      this.addressFormIsInvalid = state
    }
  },
  watch: {
    formIsInvalid: {
      handler: function () {
        this.$store.dispatch('SET_PERMISSION', {
          status: this.formIsValid,
          component: this.$route.name,
          paymentType: this.selectedPaymentType
        })
        this.tabbarError.status = false
        this.showFeedbacks.status = false
      }
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Quais as definições do boleto?",
      "dueDate": "Vencimento",
      "instructions": "Instruções",
      "instructionsPlaceholder": "Exemplo: Nao aceitar apos 4 dias do vencimento",
      "hint": {
        "required": "Este campo é obrigatório",
        "dueDate": "O vencimento não pode ser inferior ou igual a data de hoje ({date})"
      },
      "address": {
        "title": "Endereço de cobrança",
        "checkbox": "Utilizar endereço do cliente"
      },
      "customer": "Dados do Cliente",
      "review": "Resumo",
      "tabbarError": "Alguns campos não foram preenchidos corretamente, por favor verifique."
    },
    "en-US": {
      "title": "What are the payment settings?",
      "dueDate": "Due date",
      "instructions": "Instructions",
      "instructionsPlaceholder": "Example: Do not accept payment 4 days after due date",
      "hint": {
        "required": "this field is required",
        "dueDate": "The due date must be greater than the current date ({date})"
      },
      "address": {
        "title": "Billing address",
        "checkbox": "Use client address"
      },
      "customer": "Customer",
      "review": "Review",
      "tabbarError": "Some fields were filled incorrectly, please verify"
    }
  }
</i18n>
